import React from 'react'
import { any, async, AsyncState, fromJSX, loadingAsyncState, Updater, Widget } from 'widgets-for-react'
import { SpaarneCentrumType } from '../../../../utils/spaarneIcons'
import { convertReactNodeToString, slugify } from '../../../../utils/utils'
import { getVimeoBackgroundVideoUrl } from '../../../../utils/video'
import { blocksWidget } from '../../blocks/blocksWidget'
import { CentrumPage, cmsPageStateUpdaters, Link, Page } from '../../cmsPageState'
import { CentrumPageHeader } from './centrumPageLayout'

export const centrumPageWidget =
  (acceptVideoCookie: () => void) =>
    (page: CentrumPage): Widget<Updater<Page>> =>
      any([
        async<boolean>(page.hasWaitingTimesState).map(cmsPageStateUpdaters.hasWaitingTimesPageStateUpdater),
        async<Link[]>(page.childrenState).map(cmsPageStateUpdaters.pageTreeStateUpdater),
        async<string>(page.videoUrl).map(cmsPageStateUpdaters.pageVideoUrlStateUpdater),
        fromJSX(setState => (
          <CentrumPageHeader
            centrum={
              page.centrum
                ? {
                  title: page.centrum?.title,
                  url: `/afdelingen-en-centra/${slugify(page.centrum.title)}`,
                }
                : undefined
            }
            videoUrl={page.videoUrl}
            title={page.title}
            intro={page.intro}
            contactItems={page.centrum.contactItems}
            image={page.image}
            link={page.link}
            waitingTimesUrl={
            page.centrum &&
            page.hasWaitingTimesState.kind === 'loaded' &&
            page.hasWaitingTimesState.value
              ? `/wachttijden?centrum=${page.centrum.title}`
              : undefined
          }
          blocks={page.blocks
              .flatMap((block) => {
                if (
                  block.kind === 'phoneNumbersBlock' ||
                  block.kind === 'quoteBlock' ||
                  block.kind === 'relatedContentBlock' ||
                  block.kind === 'locationBlock' ||
                  block.kind === 'bmiBlock'
                )
                  return []
                const title = convertReactNodeToString(block.title)
                return block.title === ''
                  ? []
                  : [
                    {
                      title: title,
                      index: block.index,
                    },
                  ]
              })
              .toArray()}
            breadcrumbs={[
              { title: 'Spaarne Gasthuis', url: '/' },
              { title: 'Afdelingen en Centra', url: '/afdelingen-en-centra' },
              { title: page.title, url: page.url },
            ]}
            menuItems={
              page.childrenState.kind === 'loaded'
                ? page.childrenState.value.map((child) => ({ ...child, active: child.url == page.url }))
                : undefined
            }
            menuOpened={page.menuOpened}
            appointmentUrl={page.centrum?.appointmentUrl}
          />
        )),
        blocksWidget(acceptVideoCookie, {
          centrum: page.centrum
            ? { title: page.centrum.title, id: page.centrum.id }
            : undefined
        })(page.blocks).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),
      ])

const defaultBackgroundVideo = loadingAsyncState(() => getVimeoBackgroundVideoUrl('393455581?h=9e1d06e4da', '291a6f7936'))

export const centrumVideoAndFallbackImage = (centrum: SpaarneCentrumType): AsyncState<string> => {
  switch (centrum)
  {
    case 'Asherman expertisecentrum': return defaultBackgroundVideo
    case 'Baria Nederland': return defaultBackgroundVideo
    case 'Bekkenbodem centrum': return defaultBackgroundVideo
    case 'Borstzorg centrum': return defaultBackgroundVideo
    case 'centrum Ouderengeneeskunde': return defaultBackgroundVideo
    case 'Geheugen centrum': return defaultBackgroundVideo
    case 'Oncologie centrum': return defaultBackgroundVideo
    case 'Orthopedie centrum': return defaultBackgroundVideo
    case 'Thuismonitoring centrum': return defaultBackgroundVideo
    case 'Trauma centrum': return defaultBackgroundVideo
    case 'Vrouw & Kind centrum': return defaultBackgroundVideo
  } 
}
